// extracted by mini-css-extract-plugin
export default {"resetButton":"bVHs9T6","shortTimer":"_nZ4ZP2","timerValue":"Nog2lCZ","accented":"FWThExJ","longTimer":"IMpj2PG"};